/* eslint-disable no-underscore-dangle */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Publication } from '../../../model/publication';
import { PublicationService } from '../../../service/publication.service';
import { HisBaseGlobalsService, HisNotificationService } from 'hisng';
import { DynamicContentUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-content-utils';
import { DynamicFormGroupUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-form-group-utils';

@Component({
    selector: 'res-publication-change-request-form',
    templateUrl: './publication-change-request-form.component.html',
})
export class PublicationChangeRequestFormComponent implements OnInit {
    public publication: Publication = new Publication();
    public reloadTrigger = true;
    public showBackButton = false;
    public showSearchButton = false;
    public isNewChangeRequest = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private publicationService: PublicationService,
        private dynamicFormGroupUtils: DynamicFormGroupUtils,
        private notificationService: HisNotificationService,
        public hisBaseGlobalsService: HisBaseGlobalsService,
        public dynamicContentUtils: DynamicContentUtils
    ) {}

    ngOnInit() {
        this.route.params.subscribe( (params: Params) => {
            if (this.router.routerState.snapshot.url.includes('change-request')) {
                if (params.publicationId) {
                    const publicationId = parseInt(params.publicationId, 10);
                    this.publicationService.getPublicationById(publicationId).subscribe( (p: Publication) => {
                        this.publication = p;
                        this.isNewChangeRequest = p.changeRequest?.id == null;
                    });

                }
            }
        });
        this.route.queryParams.subscribe( (queryParams: Params) => {
            this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
            this.showSearchButton = queryParams.showSearchButton ? queryParams.showSearchButton === 'true' : this.showSearchButton;
        });
    }

    existChanges(): boolean {
        //activate button sendtovalidierung only if there are changes
        return true;
    }

    saveChangeRequest() {
        if(this.existChanges()){
            this.dynamicFormGroupUtils.setDynamicComponentObject(this.publication.changeRequest);
            this.publicationService.savePublicationWithCahangeRequest(this.publication).subscribe( (p: Publication) => {
                this.publication = p;
                this.showSuccessfullMessage();
            });
        }

    }

    reset() {
        if (this.publication.id) {
            this.publication._dynamicComponent = null;
            this.publicationService.getPublicationById(this.publication.id).subscribe( (p: Publication) => {
                this.publication = p;
            });
        }
    }

    showSuccessfullMessage() {
        this.notificationService.successI18nRes('fs.res.publication.changeRequest.successfullySavedForValidation');
    }
}
